import React, { memo, useCallback } from "react";

import { Box, Tooltip } from "@mui/material";

import { Emoticon } from "@/extensions/obituary/types";

export interface EmoticonButtonProps extends Emoticon {
  onEmoticonClick: (emoticon: Emoticon) => void;
  selected?: boolean;
}

const EmoticonButton: React.FC<EmoticonButtonProps> = ({
  code,
  name,
  char,
  image,
  onEmoticonClick,
  selected = false,
}) => {
  const handleClick = useCallback(() => {
    onEmoticonClick({ code, char, name, image });
  }, [code, char, name, image, onEmoticonClick]);

  return (
    <Tooltip
      arrow
      disableInteractive
      slotProps={{
        tooltip: {
          sx: {
            zIndex: (theme) => theme.zIndex.tooltip + 1,
            pointerEvents: "none",
          },
        },
      }}
      title={name}
    >
      <Box
        aria-label={`Lägg in ${name}`}
        role="button"
        sx={{
          width: 28,
          height: 28,
          cursor: "pointer",
          backgroundColor: "white",
          borderRadius: "50%",
          border: selected ? "2px solid" : "1px solid transparent",
          borderColor: selected ? "primary.main" : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: 0.5,
        }}
        tabIndex={-1}
        onClick={handleClick}
      >
        <img
          alt={name}
          src={`/emoticons/${image}`}
          style={{ height: "20px", width: "auto", display: "block" }}
        />
      </Box>
    </Tooltip>
  );
};

export default memo(EmoticonButton);
